module.exports = __webpack_public_path__ + "static/level-7.bc73e9f9.png";